import { RootState } from 'store/types'

export const getMainModerationSelector = (state: RootState) => state.moderation
